// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_I2s","cls2":"ProfilePdfPackCard-cls2_TvF ProfilePdfPackCard-cls1_I2s"};